import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Input, message, Typography } from 'antd'
import { Controller, useForm } from 'react-hook-form'
import TopBar from './TopBar'
import { database } from '../../utils/firebase'
import { useNavigate, useParams } from 'react-router-dom'

const { Text } = Typography
const { TextArea } = Input

const WriteSoapNotes = () => {
  const [labDetails, setLab] = useState(null)
  const { chatID } = useParams()
  const { control, handleSubmit, reset, formState: { errors } } = useForm()
  const navigate = useNavigate()
  const fetchLabDetails = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setLab(response)
    })
  }

  useEffect(() => {
    fetchLabDetails(chatID)
  }, [chatID])

  const onSubmit = async (data) => {
    if (Object.keys(errors).length > 0) {
      message.error('Please fill in all required fields.')
      return
    }

    try {
      const updates = {}
      if (labDetails.conversationID) {
        const _chatID = labDetails.conversationID
        const isChatOpen = await database.ref(`/openconversations/${_chatID}`).once('value').then((r) => Boolean(r.val()))

        updates[`/${isChatOpen ? 'openconversations' : 'archiveConversations'}/${_chatID}/soapNotesData`] = data.soapNotes
        await database.ref().update(updates)
        console.log('SOAP Notes:', data)
        navigate(-1)
      }
    } catch (error) {
      console.error('Error updating SOAP Notes:', error)
      message.error('Error saving SOAP Notes.')
    }
  }

  return (
    <div>
      <TopBar title="SOAP Notes" />
      <Flex gap="small" style={{ padding: '5px' }}>
        <Text strong style={{ marginLeft: '10px' }}>{labDetails?.patientName}</Text>
        <Text>Diagnosis - {labDetails?.assessment}</Text>
      </Flex>
      <Flex gap="large" style={{ padding: '5px' }}>
        <Text style={{ marginLeft: '10px' }}>Chat ID:</Text>
        <Text>{chatID}</Text>
      </Flex>
      <Divider style={{ margin: 0 }} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex gap="small" vertical style={{ padding: '13px' }}>
          <Text strong>Subjective Symptoms:</Text>
          <Controller
            name="soapNotes.symptoms"
            control={control}
            defaultValue=""
            rules={{ required: 'Subjective Symptoms are required' }}
            render={({ field }) => (
              <>
                <TextArea rows={4} {...field} />
                {errors.subjectiveSymptoms && <Text type="danger">{errors.subjectiveSymptoms.message}</Text>}
              </>
            )}
          />
        </Flex>
        <Flex gap="small" vertical style={{ padding: '13px' }}>
          <Text strong>Objective Symptoms:</Text>
          <Controller
            name="soapNotes.findings"
            control={control}
            defaultValue=""
            rules={{ required: 'Objective Symptoms are required' }}
            render={({ field }) => (
              <>
                <TextArea rows={4} {...field} />
                {errors.objectiveSymptoms && <Text type="danger">{errors.objectiveSymptoms.message}</Text>}
              </>
            )}
          />
        </Flex>
        <Flex gap="small" vertical style={{ padding: '13px' }}>
          <Text strong>Assessment:</Text>
          <Controller
            name="soapNotes.assessment"
            control={control}
            defaultValue=""
            rules={{ required: 'Assessment is required' }}
            render={({ field }) => (
              <>
                <TextArea rows={4} {...field} />
                {errors.assessment && <Text type="danger">{errors.assessment.message}</Text>}
              </>
            )}
          />
        </Flex>
        <Flex gap="small" vertical style={{ padding: '13px' }}>
          <Text strong>Plan:</Text>
          <Controller
            name="soapNotes.plan"
            control={control}
            defaultValue=""
            rules={{ required: 'Plan is required' }}
            render={({ field }) => (
              <>
                <TextArea rows={4} {...field} />
                {errors.plan && <Text type="danger">{errors.plan.message}</Text>}
              </>
            )}
          />
        </Flex>
        <Flex vertical style={{ padding: '24px', background: '#f9f9f9', alignItems: 'center' }} gap="small">
          <Button
            htmlType="submit"
            type="primary"
            shape="round"
            style={{
              width: '180px',
              marginBottom: '3px',
              backgroundColor: '#DF7467',
              borderColor: '#DF7467',
            }}
          >
            Save SOAP Notes
          </Button>
          <Button
            onClick={() => reset()}
            type="default"
            shape="round"
            style={{
              width: '180px',
              borderColor: '#DF7467',
              color: '#DF7467',
            }}
          >
            Cancel SOAP Notes
          </Button>
        </Flex>
      </form>
    </div>
  )
}

export default WriteSoapNotes
